import {
  ADD_RATERS_INVITES,
  EDIT_RATERS_INVITES,
  LIST_RATERS_INVITES,
  VIEW_RATERS_INVITES,
  DELETE_RATERS_INVITES,
  // text
  ADD_RATERS_INVITES_TEXT,
  EDIT_RATERS_INVITES_TEXT,
  LIST_RATERS_INVITES_TEXT,
  VIEW_RATERS_INVITES_TEXT,
  DELETE_RATERS_INVITES_TEXT,
  RATERS_INVITES_SUCCESS,
  RATERS_INVITES_ERROR,
} from "./actionTypes"

// add raters invites
export const addRatersInvites = (data, history, callback) => {
  return {
    type: ADD_RATERS_INVITES,
    payload: { data, history, callback }
  }
}

// edit raters invites
export const editRatersInvites = (data, id, callback) => {
  return {
    type: EDIT_RATERS_INVITES,
    payload: { data, id, callback },
  }
}

// list raters invites
export const listRatersInvites = (data, callback) => {
  return {
    type: LIST_RATERS_INVITES,
    payload: { data, callback },
  }
}

// view raters invites
export const viewRatersInvites = (data, history) => {
  return {
    type: VIEW_RATERS_INVITES,
    payload: { data, history },
  }
}

// delete raters invites
export const deleteRatersInvites = (data, callback) => {
  return {
    type: DELETE_RATERS_INVITES,
    payload: { data, callback },
  }
}

// text
// add Invites
export const addRatersInvitesText = (data, history, callback) => {
  return {
    type: ADD_RATERS_INVITES_TEXT,
    payload: { data, history, callback }
  }
}

// edit Invites
export const editRatersInvitesText = (data, id, callback) => {
  return {
    type: EDIT_RATERS_INVITES_TEXT,
    payload: { data, id, callback },
  }
}

// list Invites
export const listRatersInvitesText = (data, id, callback) => {
  return {
    type: LIST_RATERS_INVITES_TEXT,
    payload: { data, id, callback },
  }
}

// view Invites
export const viewRatersInvitesText = (data, history) => {
  return {
    type: VIEW_RATERS_INVITES_TEXT,
    payload: { data, history },
  }
}

// delete Invites
export const deleteRatersInvitesText = (data, callback) => {
  return {
    type: DELETE_RATERS_INVITES_TEXT,
    payload: { data, callback },
  }
}

export const ratersInvitesSuccess = message => {
  return {
    type: RATERS_INVITES_SUCCESS,
    payload: message,
  }
}

export const ratersInvitesError = message => {
  return {
    type: RATERS_INVITES_ERROR,
    payload: message,
  }
}
